import { useLanguage } from "../../contexts/LanguageContext";
import radio from "../pictures/bao.jpg"
function Radio() {
  const { t } = useLanguage();
  return (
    <section id="radio" className="animate-fade-in py-12 min-h-full">
      <h1 className="text-5xl font-bold text-center mb-10 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-cyan-500 leading-tight p-1">
        {t('radioTitle')}
      </h1>
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="order-2 md:order-1">
          <h2 className="text-3xl font-bold text-white mb-4">{t('radioSubtitle')}</h2>
          <p className="text-gray-400 leading-loose">
            {t('radioText1')}
          </p>
          <p className="text-gray-400 leading-loose mt-4">
            {t('radioText2')}
          </p>
        </div>
        <div className="order-1 md:order-2 group">
           <img 
              src={radio} 
              style={{maxHeight:"700px"}}
              alt="Shortwave radio station" 
              className="rounded-lg shadow-lg w-full h-auto object-cover transition-all duration-300 transform group-hover:scale-105 group-hover:shadow-cyan-500/20"
            />
        </div>
      </div>
    </section>
  );
};

export default Radio;